import { create } from 'zustand';

export const useFilterStore = create((set) => ({
  // Tracks if maturity range has been edited by the user (not prefill)
  maturityEditedByUser: false,
  setMaturityEditedByUser: (edited) => set({ maturityEditedByUser: edited }),
  resetMaturityEditedByUser: () => set({ maturityEditedByUser: false }),
}));
